// Check if field is empty
export const isValidInput = value => {
	if (!value) {
		return false;
	}
	return true;
};

// Check if valid email
export const isValidEmail = value => {
	/* eslint-disable-next-line  no-useless-escape */
	if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
		return true;
	}
	return false;
};
